// extracted by mini-css-extract-plugin
export default {"container":"XZ-z","heading":"YZ-z","links":"ZZ-z","copy":"_Z-z","subCopy":"a0-z","linksLeft":"b0-z","linksCenter":"c0-z","linksRight":"d0-z","link":"e0-z","onlyLink":"f0-z"};